/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { useState, forwardRef } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import Button from "@mui/material/Button";
import Slide from "@mui/material/Slide";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import { configState } from "../lib/State";
import {
  Select,
  MenuItem,
  RadioGroup,
  Radio,
  FormControlLabel,
  FormLabel,
  Box,
} from "@mui/material";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

// 등록하기 팝업
export default function ReportMarketingQuestionAdd({ login, onClose }) {
  const token = localStorage.getItem("token");
  const [data, setData] = useState({
    active: "Y",
    gubun: "",
    question: "",
  });

  const onSubmit = async () => {
    let result = await axios.post(
      `${process.env.REACT_APP_API}/gympass_admin/ma_question_add`,
      {
        token: token,
        level: login.level,
        mcd: login.mcd,
        ...data,
      }
    );

    if (result.data.success === 0) {
      Swal.fire("Error", result.data.msg);
      return;
    } else {
      onClose();
    }
  };

  const changeData = (e) => {
    setData((state) => {
      return { ...state, [e.target.name]: e.target.value };
    });
  };

  return (
    <Box sx={{ padding: "10px" }}>
      {/* 포인트구분 */}
      <FormControl
        css={css`
          margin-top: 10px;
        `}
      >
        <InputLabel id="demo-simple-select-label" size="small">
          구분
        </InputLabel>
        <Select
          name="gubun"
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          css={css`
            width: 160px;
          `}
          label="구분"
          size="small"
          value={data.gubun}
          onChange={changeData}
        >
          <MenuItem value="마케팅">마케팅</MenuItem>
          <MenuItem value="근무태도">근무태도</MenuItem>
          <MenuItem value="FC업무">FC업무</MenuItem>
        </Select>
      </FormControl>

      <FormControl sx={{ mt: 1, display: "block" }}>
        <TextField
          name="question"
          sx={{ width: "100%" }}
          onChange={changeData}
          size="small"
          label="문항"
          autoComplete="off"
          multiline
          rows={3}
          value={data.question}
        ></TextField>
      </FormControl>

      <FormControl fullWidth sx={{ mt: 1, pl: 0.5 }}>
        <FormLabel>상태</FormLabel>
        <RadioGroup
          row
          aria-labelledby="demo-radio-buttons-group-label"
          name="active"
          onChange={changeData}
          value={data.active}
        >
          <FormControlLabel value="Y" control={<Radio />} label="Y" />
          <FormControlLabel value="N" control={<Radio />} label="N" />
        </RadioGroup>
      </FormControl>

      <Box
        sx={{
          mt: 5,
          textAlign: "center",
        }}
      >
        <Button variant="contained" onClick={() => onSubmit()}>
          등록완료
        </Button>
        <Button
          variant="contained"
          color="warning"
          css={css`
            margin-left: 10px;
          `}
          onClick={() => onClose()}
        >
          취소
        </Button>
      </Box>
    </Box>
  );
}
